import { render } from "./HomeIndex.vue?vue&type=template&id=bd5be3be&scoped=true&ts=true"
import script from "./HomeIndex.vue?vue&type=script&lang=ts"
export * from "./HomeIndex.vue?vue&type=script&lang=ts"

import "./HomeIndex.vue?vue&type=style&index=0&id=bd5be3be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5be3be"]])

export default __exports__